import { Avatar, Box, Button, Container, Heading, HStack, Stack, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { RiSecurePaymentFill } from 'react-icons/ri';
import { Link } from 'react-router-dom';
import mainVideo from "../../../src/assets/videos/Black General Subjects Online Education YouTube Video Ad.mp4"
const Founder = () =>(
    <Stack direction={['column','row']} spacing={['4','16']} padding='8'>
        <VStack>
            <Avatar src='https://i.imgflip.com/6h4kta.jpg' boxSize={['40','48']}/>
            <Text children='Owner' opacity={0.7} />
        </VStack>
        <VStack justifyContent={'center'} alignItems={['center','flex-start']}>
            <Heading children='Abhinav' size={['md','xl']} />
            <Text textAlign={['center','left']} children={"My name is Abhinav"} />
        </VStack>
    </Stack>
);

const VideoPlayer = () => (
    <Box>
        <video 
        autoPlay 
        controls 
        controlsList="nodownload nofullscreen noremoteplayback" 
        disablePictureInPicture
        disableRemotePlayback
        src={mainVideo}
        >
        </video>
    </Box>
);

const TnC = ({termsAndCondition}) =>(
    <Box>
        <Heading size={'md'} children='terms & Conditions' textAlign={['center','left']} my='4' />
        <Box h='sm' p='4' overflowY={'scroll'}>
            <Text textAlign={['center','left']} fontFamily={'heading'} letterSpacing={'widest'}>
                {termsAndCondition}
            </Text>
            <Heading my='4' size={'xs'} children="Refund only applicable for cancellation within 7 days"/>
        </Box>
    </Box>
)

const AboutPage = () => {
  return (
    <Container maxW={'container.lg'} padding='16' boxShadow={'lg'}>
        <Heading children='About Us' textAlign={['center','left']}/>

        <Founder />

        <Stack m='8' direction={['column','row']} alignItems='center'>
            <Text>
                Learning should never stop!
                We provide good courses along with some paid excellent courses.
            </Text>
            <Link to="/subscribe">
                <Button variant='outline' colorScheme='yellow'>
                    Check our Plans
                </Button>
            </Link>
        </Stack>

        <VideoPlayer />

        {/* <TnC termsAndCondition={'termsAndConditions'} /> */}

        <HStack my='4' p={'4'}>
            <RiSecurePaymentFill />
            <Heading size={'xs'} textTransform={'uppercase'} children={'Payment is secured by RazorPay'} />
        </HStack>
    </Container>
  )
}

export default AboutPage